export const API_BASE_URL = 'https://api.edocument.demo.nawatech.co';
// export const API_BASE_URL = 'https://localhost:7238'
export const LOCAL_BASE_URL = 'https://localhost:7238';

// Auth
export const LOGIN_API = `${API_BASE_URL}/auth/authentication`;
export const REFRESH_API = `${API_BASE_URL}/auth/refresh`;

// Master Data - Item
export const GET_ITEM_API = `${API_BASE_URL}/api/MsItem`;
export const GET_ID_ITEM_API = `${API_BASE_URL}/api/MsItem`;
export const CREATE_ITEM_API = `${API_BASE_URL}/api/MsItem`;
export const UPDATE_ITEM_API = `${API_BASE_URL}/api/MsItem`;
export const DELETE_ITEM_API = `${API_BASE_URL}/api/MsItem`;
export const UPLOAD_ITEM_API = `${API_BASE_URL}/api/MsItem/upload`;
export const SUBMIT_ITEM_API = `${API_BASE_URL}/api/MsItem/submit`;
export const SOFT_DELETE_ITEM_API = `${API_BASE_URL}/api/MsItem/soft`;

// Master Data - Price
export const GET_PRICE_API = `${API_BASE_URL}/api/MsPrice`;
export const GET_ID_PRICE_API = `${API_BASE_URL}/api/MsPrice`;
export const CREATE_PRICE_API = `${API_BASE_URL}/api/MsPrice`;
export const UPDATE_PRICE_API = `${API_BASE_URL}/api/MsPrice`;
export const DELETE_PRICE_API = `${API_BASE_URL}/api/MsPrice`;
export const UPLOAD_PRICE_API = `${API_BASE_URL}/api/MsPrice/upload`;
export const SUBMIT_PRICE_API = `${API_BASE_URL}/api/MsPrice/submit`;
export const SOFT_DELETE_PRICE_API = `${API_BASE_URL}/api/MsPrice/soft`;

// Master Data - Distributor
export const GET_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor`;
export const GET_ID_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor`;
export const CREATE_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor`;
export const UPDATE_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor`;
export const DELETE_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor`;
export const UPLOAD_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor/upload`;
export const SUBMIT_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor/submit`;
export const SOFT_DELETE_DISTRIBUTOR_API = `${API_BASE_URL}/api/MsDistributor/soft`;

// Master Data - Shipment
export const GET_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment`;
export const GET_ID_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment`;
export const CREATE_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment`;
export const UPDATE_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment`;
export const DELETE_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment`;
export const UPLOAD_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment/upload`;
export const SUBMIT_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment/submit`;
export const SOFT_DELETE_SHIPMENT_API = `${API_BASE_URL}/api/MsShipment/soft`;

// Document - OCR
export const UPLOAD_DOCUMENT = `${API_BASE_URL}/api/Document/upload`;
export const SUMMARY_DOCUMENT = `${API_BASE_URL}/api/Document/summary`;
export const GET_DOCUMENT = `${API_BASE_URL}/api/Document`;
export const GET_ID_DOCUMENT = `${API_BASE_URL}/api/Document`;
export const SUBMIT_DOCUMENT = `${API_BASE_URL}/api/Document/submit`;

// Dropdown
export const DROPDOWN = `${API_BASE_URL}/api/DropDown`;
export const DROPDOWN_WAREHOUSE = `${API_BASE_URL}/api/DropDown/Warehouse`;
export const DROPDOWN_PRODUCT = `${API_BASE_URL}/api/DropDown/ProductByDesc`;

// Report
export const DOWNLOAD_REPORT = `${API_BASE_URL}/api/Report/download`;
export const DOWNLOAD_SUMMARY_REPORT = `${API_BASE_URL}/api/Report/downloadDetail`;

export const LOGOUT = `${API_BASE_URL}/auth/authentication`;
